'use client';
import React from 'react';
import { useRouter, useParams } from 'next/navigation';
import { SearchBar as SharedSearchBar } from '@launchstore/shared-puck';
import type { SearchBarProps } from '@launchstore/shared-puck';

const SharedSearchBarRender = (SharedSearchBar as any).render;

const SearchBarImpl: React.FC<SearchBarProps> = (props: any) => {
  const router = useRouter();
  const params = useParams();
  const countryCode = (params?.countryCode as string) || 'us';
  return (
    <SharedSearchBarRender
      {...(props as any)}
      onSearch={(q: string) => router.push(`/${countryCode}/search?q=${encodeURIComponent(q)}`)}
    />
  );
};

export const SearchBar: any = { ...SharedSearchBar, render: (props: any) => <SearchBarImpl {...props} /> };
export default SearchBar;
